import { useController } from 'react-hook-form';
import { SelectProps, BaseOption } from 'ui/selectv2/types';
import { MultiSelect } from 'ui/selectv2/MultiSelect';
import { FieldProps } from './types';

export type MultiSelectFieldProps = FieldProps & Omit<SelectProps, 'value' | 'onSelect'>;

export const MultiSelectField = ({ name, ...rest }: MultiSelectFieldProps) => {
  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({
    name,
    defaultValue: null,
  });

  const values = rest?.options?.filter((x: BaseOption) => value?.includes?.(x.value));

  return (
    <MultiSelect
      errorMsg={error?.message}
      onSelect={(val: BaseOption[]) => {
        const selectedValues = val.map((x: BaseOption) => x.value);
        onChange(selectedValues);
      }}
      {...rest}
      value={values}
    />
  );
};
